// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function stripTags(str: any) {
  if (str === null || str === '') return false;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-param-reassign
  str = str.toString();
  return str.replace(/<[^>]*>/g, ' ');
}
